import { OverrideApprovalRequestSchema, OverrideApprovalResponseSchema } from './override-approval.schema';
export const overrideApprovalContract = {
    method: 'POST',
    path: '/api/v2/approval/:id/override',
    description: 'Release an approval without the reviewers, with a reason',
    requestSchema: OverrideApprovalRequestSchema,
    responseSchema: OverrideApprovalResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Not pending, or the rule does not allow it',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - not a workspace admin',
            404: 'Approval not found'
        }
    }
};

//# sourceMappingURL=override-approval.contract.js.map